import { c as _c } from "react/compiler-runtime";
import { useGetBulkDialogContent } from "@components/common/faro-table/bulk-dialog/bulk-dialog-helper";
import { bulkActionResultsSelector, numberOfUpdatingItemsSelector } from "@store/table/table-selector";
import { useAppSelector } from "@store/store-helper";
import { nounPluralize } from "@utils/data-display";

/** Determines the content of bulk dialog and bulk success dialog for deleting project */
export function useDeleteProjectBulkDialogContent() {
  const $ = _c(10);
  const numberOfUpdatingItems = useAppSelector(numberOfUpdatingItemsSelector);
  const {
    numberOfSuccess,
    numberOfErrors
  } = useAppSelector(bulkActionResultsSelector);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      title: "Delete these projects from workspace?",
      description: "When you confirm this action, all the data of these projects will be lost and cannot be recovered"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = `Couldn't delete ${numberOfErrors} of ${numberOfUpdatingItems} projects`;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      initial: t0,
      failed: {
        title: t1,
        description: "These projects couldn't be deleted from workspace, check the details and try again."
      },
      confirmButtonText: "delete",
      entityType: "project"
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const bulkDialogContent = useGetBulkDialogContent(t2);
  let t3;
  if ($[3] !== numberOfSuccess) {
    t3 = nounPluralize({
      counter: numberOfSuccess,
      word: "project"
    });
    $[3] = numberOfSuccess;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `${t3} deleted`;
  let t5;
  if ($[5] !== t4) {
    t5 = {
      title: t4,
      description: "All selected projects have been permanently deleted"
    };
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const successDialogContent = t5;
  let t6;
  if ($[7] !== bulkDialogContent || $[8] !== successDialogContent) {
    t6 = {
      bulkDialogContent,
      successDialogContent
    };
    $[7] = bulkDialogContent;
    $[8] = successDialogContent;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}